// Function to encode a UTF-8 string to Base64
export function utf8ToBase64 (str) {
  const encoder = new TextEncoder()
  const data = encoder.encode(str)

  const binaryString = String.fromCharCode.apply(null, data)
  return btoa(binaryString)
}

// Function to decode a Base64 string to UTF-8
export function base64ToUtf8 (b64) {
  const binaryString = atob(b64)
  // Create a Uint8Array from the binary string.
  const bytes = new Uint8Array(binaryString.length)
  for (let i = 0; i < binaryString.length; i++) {
    bytes[i] = binaryString.charCodeAt(i)
  }
  const decoder = new TextDecoder()
  return decoder.decode(bytes)
}
